export const currencyConventions = {
  DEFAULT: {
    inputPrecision: { min: 0, max: 2 },
    outputPrecision: { min: 2, max: 4 },
    balanceOutputPrecision: { min: 2, max: 2 },
  },
  BTC: {
    inputPrecision: { min: 0, max: 8 },
    outputPrecision: { min: 2, max: 8 },
    balanceOutputPrecision: { min: 2, max: 8 },
  },
  ETH: {
    inputPrecision: { min: 0, max: 8 },
    outputPrecision: { min: 2, max: 8 },
    balanceOutputPrecision: { min: 2, max: 8 },
  },
}
